"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FaceUnhappyOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FaceUnhappyOutlineSVG = function FaceUnhappyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm0,2A12,12,0,1,0,28,16,12,12,0,0,0,16,4Zm5.6,14a1,1,0,1,1,.1,2l-.31,0a21.39,21.39,0,0,0-4.41.82l-.55.18A18.57,18.57,0,0,0,14,22.14c-.42.22-.82.45-1.19.67l-.37.23c-.29.18-.5.31-.6.39a1,1,0,0,1-1.13-1.65L11,21.6l.41-.26c.52-.32,1.09-.65,1.69-1a22.54,22.54,0,0,1,2.26-1l.51-.18a22.73,22.73,0,0,1,5.39-1.09ZM12,11a2,2,0,1,1-2,2A2,2,0,0,1,12,11Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  }));
};
exports.FaceUnhappyOutlineSVG = FaceUnhappyOutlineSVG;
FaceUnhappyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FaceUnhappyOutlineSVG);
exports.default = _default;